export const currencyFormatter = new Intl.NumberFormat(undefined, {
    currency: "pln",
    style: "currency",
    minimumFractionDigits: 0,

})